import { render } from "./1229589b-7d96-11eb-811b-00155d01060e.vue?vue&type=template&id=48fb19da"
import script from "./1229589b-7d96-11eb-811b-00155d01060e.vue?vue&type=script&lang=js"
export * from "./1229589b-7d96-11eb-811b-00155d01060e.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__